import { DOMAIN_CONTANTS } from "../constants/domains/domain-contants";

export const themes =
    [
        {
            key: "localhost",
            domain: DOMAIN_CONTANTS.platform,
            logo: "platform-light-logo.png",
            logoSize: 'h-75px',
            loginShape: 'platform-login-shape.png',
            loginBg: 'platform-login-bg.png',
            innerLogo: 'platform-white-logo.png',
            innerLogoSize: 'h-35px'
        },
        {
            key: "app-test.platformobase.com",
            domain: DOMAIN_CONTANTS.platform,
            logo: "platform-light-logo.png",
            logoSize: 'h-75px',
            loginShape: 'platform-login-shape.png',
            loginBg: 'platform-login-bg.png',
            innerLogo: 'platform-white-logo.png',
            innerLogoSize: 'h-35px'
        },
        {
            key: "app.platformobase.com",
            domain: DOMAIN_CONTANTS.platform,
            logo: "platform-light-logo.png",
            logoSize: 'h-75px',
            loginShape: 'platform-login-shape.png',
            loginBg: 'platform-login-bg.png',
            innerLogo: 'platform-white-logo.png',
            innerLogoSize: 'h-35px'
        },
        {
            key: "app.syncflow.ai",
            domain: DOMAIN_CONTANTS.syncflow,
            logo: "syncflow-light-logo.png",
            logoSize: "h-100px",
            loginBg: 'syncflow-login-bg.jpg',
            innerLogo: 'syncflow-light-logo-inner.png',
            innerLogoSize: 'h-55px'
        },
        {
            key: "app-test.syncflow.ai",
            domain: DOMAIN_CONTANTS.syncflow,
            logo: "syncflow-light-logo.png",
            logoSize: "h-100px",
            loginBg: 'syncflow-login-bg.jpg',
            innerLogo: 'syncflow-light-logo-inner.png',
            innerLogoSize: 'h-55px'
        }
    ];